import InputFakePassword from './InputFakePassword'
export default InputFakePassword;